module.exports = __webpack_public_path__ + "img/55.adda9aea.jpg";